class TicketController extends AbstractController
	@register()
	@inject '$filter',
		'$scope'
		'parseBool'
		'ticket'
		'event'
		'RenderRepository'
		'TicketRepository'
		'ToastService'
		'MessageTerminal'

	initialize: ->
		if _.isEmpty @ticket
			return

		@mainCrud.entityType = 'general.ticket'
		@mainCrud.entityTitle = @ticket.type.name
		@mainCrud.entityTitle += ": #{@ticket.product_variant.product_variant_name}" if @ticket.product_variant?
		@mainCrud.afterHeaderTitle = @ticket.id
		@mainCrud.showFormActionButtons = false

		@ticket.is_active = @parseBool(@ticket.is_active)

		@isValidTicket = @ticket.expire_time == null || @ticket.expire_time > moment().unix()
		@email = @ticket.email

		@setInformationLinks()
		@MessageTerminal.on @$scope,
			@MessageTerminal.events.DISPLAY_LANGUAGE,
			=> @setInformationLinks()

	setInformationLinks: ->
		@fullInformationLink = @RenderRepository.getRenderUrl('tickets', @ticket.id, 'pdf')
		@fullRelatedInformationLink = @RenderRepository.getRenderUrl('tickets', @ticket.id, 'pdf', 'render_order')

	resendEmail: (saveEmail = false) ->
		body = {
			send_email: @email
		}
		body.email = @email if saveEmail

		@TicketRepository
			.patch @ticket.id, body
			.then (response) =>
				@ToastService.add(
					response.data.success,
					@$filter('translate')('general.ticket'),
					@$filter('translate')('bounty.email.sent'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @$filter('translate')('general.ticket')
